var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUdfLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 481,
    height: 175,
    viewBox: "0 0 481 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_261_3400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.918 44.8486C218.208 44.8486 218.353 44.9935 218.353 45.2831V56.3866C218.353 60.2486 218.015 62.6624 217.243 64.5452C215.891 67.2969 213.525 68.021 208.939 68.0693C205.029 68.0693 202.856 67.5383 201.408 65.7038C199.96 63.8693 199.477 61.2141 199.477 56.3866V45.2831C199.477 44.9935 199.622 44.8486 199.912 44.8486H203.677C203.967 44.8486 204.112 44.9935 204.112 45.2831V56.3866C204.112 59.3797 204.449 61.4073 205.077 62.421C205.705 63.4348 207.008 63.9176 208.891 63.9176C210.774 63.9176 212.029 63.3866 212.656 62.421C213.284 61.4073 213.622 59.3797 213.622 56.3866V45.2831C213.622 44.9935 213.767 44.8486 214.056 44.8486H217.822H217.918Z",
    fill: "#391D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.137 44.8486C241.427 44.8486 241.571 44.9935 241.571 45.3314V67.4417C241.571 67.7797 241.427 67.9245 241.137 67.9245H238.385C237.758 67.9245 237.275 67.6831 236.889 67.2004L227.137 52.8624V67.4417C227.137 67.7797 226.992 67.9245 226.702 67.9245H222.937C222.647 67.9245 222.502 67.7797 222.502 67.4417V45.3314C222.502 44.9935 222.647 44.8486 222.937 44.8486H225.882C227.137 44.9452 227.137 45.0417 227.716 45.8141L236.937 59.3314V45.3314C236.937 44.9935 237.082 44.8486 237.371 44.8486H241.137Z",
    fill: "#391D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.072 44.8486C250.362 44.8486 250.507 44.9935 250.507 45.3314V67.4417C250.507 67.7797 250.362 67.9245 250.072 67.9245H246.307C246.017 67.9245 245.872 67.7797 245.872 67.4417V45.3314C245.872 44.9935 246.017 44.8486 246.307 44.8486H250.072Z",
    fill: "#391D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.263 44.8486C257.263 44.8486 257.553 44.9452 257.697 45.3314L262.332 63.3383C262.525 64.0141 262.622 64.2073 263.008 64.2073C263.442 64.2073 263.539 64.0141 263.732 63.3383L268.318 45.3314C268.415 44.9935 268.511 44.8486 268.753 44.8486H272.566C272.904 44.8486 273.001 44.9935 272.904 45.3314L267.98 64.5452C267.546 66.1383 267.063 67.1521 266.532 67.5383C266.001 67.9245 264.842 68.1176 263.008 68.1176C261.173 68.1176 260.111 67.9245 259.58 67.5383C259.049 67.1521 258.566 66.1383 258.132 64.5452L253.111 45.3314C253.015 44.9935 253.111 44.8486 253.449 44.8486H257.263Z",
    fill: "#391D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.91 44.8514C291.2 44.8514 291.345 44.9963 291.345 45.2859V48.4721C291.345 48.7618 291.2 48.9066 290.91 48.9066H280.193V54.5549H289.945C290.283 54.5549 290.428 54.6997 290.428 54.9894V58.0307C290.428 58.3204 290.283 58.4652 289.945 58.4652H280.193V63.7756H290.91C291.2 63.7756 291.345 63.9204 291.345 64.2101V67.3963C291.345 67.6859 291.2 67.8307 290.91 67.8307H275.993C275.703 67.8307 275.559 67.6859 275.559 67.348V45.1894C275.559 44.8997 275.703 44.7549 275.993 44.7549H290.91V44.8514Z",
    fill: "#391D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.075 46.2967C311.378 47.3587 312.006 49.3863 312.006 52.3311C312.006 54.5518 311.668 56.1932 310.992 57.2553C310.316 58.2691 309.157 58.9449 307.419 59.2829L312.488 67.3449C312.73 67.6829 312.585 67.9242 312.151 67.9242H308.385C307.757 67.9242 307.516 67.7311 307.178 67.2484L302.302 59.5725H299.55V67.4415C299.55 67.8277 299.454 67.9242 299.116 67.9242H295.35C295.013 67.9242 294.916 67.8277 294.916 67.4415V45.4277C294.916 45.0898 295.013 45.0415 295.35 44.9932C297.764 44.8001 300.371 44.6553 303.268 44.6553C306.599 44.6553 308.819 45.1863 310.075 46.2967ZM299.55 48.7587V55.9518H302.785C304.619 55.9518 305.826 55.7587 306.406 55.3242C306.985 54.8898 307.275 53.9242 307.275 52.4277C307.275 50.9311 306.985 49.9656 306.406 49.4829C305.826 48.9518 304.619 48.7104 302.833 48.7104H299.599L299.55 48.7587Z",
    fill: "#391D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.435 45.236C329.773 45.3325 329.966 45.5256 329.966 45.767V48.1808C329.966 48.5187 329.773 48.7118 329.387 48.7118H322.338C320.504 48.7118 319.587 49.3877 319.587 50.6429V51.0774C319.587 52.1394 320.166 52.8636 321.325 53.2981L326.876 55.4705C328.373 56.0498 329.435 56.8222 330.062 57.6912C330.69 58.5601 331.028 59.8153 331.028 61.4567V62.2774C331.028 66.4291 328.035 68.0222 322.435 68.0222C320.118 68.0222 317.704 67.8291 315.049 67.3946C314.711 67.2981 314.566 67.1049 314.566 66.7187V64.4498C314.566 64.1118 314.759 63.9187 315.145 63.9187H323.593C325.428 63.9187 326.297 63.2912 326.297 62.0843V61.6981C326.297 60.3946 325.718 59.8153 324.173 59.236L318.38 57.0636C315.869 56.0981 314.856 54.4084 314.856 50.9808V50.305C314.856 46.105 317.607 44.6084 323.207 44.6084C325.138 44.6084 327.214 44.8015 329.435 45.1877V45.236Z",
    fill: "#391D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.416 44.8486C338.705 44.8486 338.85 44.9935 338.85 45.3314V67.4417C338.85 67.7797 338.705 67.9245 338.416 67.9245H334.65C334.361 67.9245 334.216 67.7797 334.216 67.4417V45.3314C334.216 44.9935 334.361 44.8486 334.65 44.8486H338.416Z",
    fill: "#391D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.608 47.407C361.105 49.2415 361.829 52.2346 361.829 56.3863C361.829 60.538 361.105 63.5311 359.608 65.3656C358.16 67.2001 355.698 68.0691 352.174 68.0691C348.939 68.0691 346.043 67.9725 343.532 67.7794C343.194 67.7794 343.098 67.6346 343.098 67.3932V45.4277C343.098 45.0898 343.194 45.0415 343.532 44.9932C345.946 44.8001 348.794 44.6553 352.174 44.6553C355.553 44.6553 358.111 45.5725 359.608 47.407ZM347.78 48.7587V63.9656H352.174C355.746 63.9656 357.098 61.7449 357.098 56.3863C357.098 51.0277 355.649 48.7587 351.932 48.7587H347.732H347.78Z",
    fill: "#391D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.454 45.2346C377.034 45.6208 377.516 46.5863 377.951 48.2277L383.213 67.4415C383.261 67.7794 383.165 67.9242 382.827 67.9242H379.013C379.013 67.9242 378.723 67.8277 378.627 67.4415L376.937 61.2622H368.923L367.185 67.4415C367.089 67.8277 367.04 67.9242 366.751 67.9242H362.985C362.647 67.9242 362.551 67.7794 362.599 67.4415L367.909 48.2277C368.344 46.6346 368.827 45.6208 369.406 45.2346C369.985 44.8484 371.096 44.6553 372.882 44.6553C374.668 44.6553 375.875 44.8484 376.454 45.2346ZM372.158 49.4346L369.985 57.3035H375.875L373.751 49.4346C373.558 48.7104 373.558 48.5656 372.93 48.5656C372.447 48.5656 372.399 48.7104 372.206 49.4346H372.158Z",
    fill: "#391D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.189 47.407C403.686 49.2415 404.41 52.2346 404.41 56.3863C404.41 60.538 403.686 63.5311 402.189 65.3656C400.741 67.2001 398.279 68.0691 394.755 68.0691C391.52 68.0691 388.624 67.9725 386.113 67.7794C385.775 67.7794 385.679 67.6346 385.679 67.3932V45.4277C385.679 45.0898 385.775 45.0415 386.113 44.9932C388.527 44.8001 391.375 44.6553 394.755 44.6553C398.134 44.6553 400.692 45.5725 402.189 47.407ZM390.361 48.7587V63.9656H394.755C398.327 63.9656 399.679 61.7449 399.679 56.3863C399.679 51.0277 398.23 48.7587 394.513 48.7587H390.361Z",
    fill: "#391D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.282 44.8514C423.572 44.8514 423.717 44.9963 423.717 45.2859V48.4721C423.717 48.7618 423.572 48.9066 423.282 48.9066H412.565V54.5549H422.317C422.655 54.5549 422.8 54.6997 422.8 54.9894V58.0307C422.8 58.3204 422.655 58.4652 422.317 58.4652H412.565V63.7756H423.282C423.572 63.7756 423.717 63.9204 423.717 64.2101V67.3963C423.717 67.6859 423.572 67.8307 423.282 67.8307H408.365C408.075 67.8307 407.931 67.6859 407.931 67.348V45.1894C407.931 44.8997 408.075 44.7549 408.365 44.7549H423.282V44.8514Z",
    fill: "#391D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.885 47.407C451.381 49.2415 452.106 52.2346 452.106 56.3863C452.106 60.538 451.381 63.5311 449.885 65.3656C448.437 67.2001 445.975 68.0691 442.45 68.0691C439.216 68.0691 436.319 67.9725 433.809 67.7794C433.471 67.7794 433.375 67.6346 433.375 67.3932V45.4277C433.375 45.0898 433.471 45.0415 433.809 44.9932C436.223 44.8001 439.071 44.6553 442.45 44.6553C445.83 44.6553 448.388 45.5725 449.885 47.407ZM438.057 48.7587V63.9656H442.45C446.023 63.9656 447.375 61.7449 447.375 56.3863C447.375 51.0277 445.926 48.7587 442.209 48.7587H438.057Z",
    fill: "#391D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.731 45.2346C467.31 45.6208 467.793 46.5863 468.228 48.2277L473.49 67.4415C473.538 67.7794 473.441 67.9242 473.104 67.9242H469.29C469.29 67.9242 469 67.8277 468.903 67.4415L467.214 61.2622H459.2L457.462 67.4415C457.366 67.8277 457.317 67.9242 457.028 67.9242H453.262C452.924 67.9242 452.828 67.7794 452.876 67.4415L458.186 48.2277C458.621 46.6346 459.104 45.6208 459.683 45.2346C460.262 44.8484 461.372 44.6553 463.159 44.6553C464.945 44.6553 466.152 44.8484 466.731 45.2346ZM462.435 49.4346L460.262 57.3035H466.152L464.028 49.4346C463.835 48.7104 463.835 48.5656 463.207 48.5656C462.724 48.5656 462.676 48.7104 462.483 49.4346H462.435Z",
    fill: "#391D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.25 88.2005C221.829 88.2005 222.119 88.4419 222.119 88.9729V97.0833C222.119 97.6143 221.878 97.8557 221.25 97.8557H205.126V104.566H219.802C220.381 104.566 220.671 104.807 220.671 105.338V112.918C220.671 113.449 220.429 113.69 219.802 113.69H205.126V129.138C205.126 129.718 204.885 130.007 204.354 130.007H194.795C194.264 130.007 194.022 129.766 194.022 129.138V88.9246C194.022 88.3453 194.264 88.0557 194.795 88.0557H221.25V88.2005Z",
    fill: "#391D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.135 129.283C258.231 129.862 258.038 130.152 257.459 130.152H248.19C247.707 130.152 247.659 130.007 247.466 129.283L244.666 118.903H232.162L229.362 129.283C229.217 129.91 229.169 130.152 228.638 130.152H219.369C218.79 130.152 218.597 129.91 218.693 129.283L228.252 94.3791C229.024 91.4343 230.038 89.5998 231.148 88.924C232.259 88.2481 234.721 87.9102 238.438 87.9102C242.155 87.9102 244.617 88.2964 245.728 88.9722C246.838 89.6481 247.852 91.4826 248.624 94.3791L258.183 129.283H258.135ZM234.576 109.876H242.203L238.776 97.3722C238.631 96.9377 238.1 96.9377 237.907 97.3722L234.576 109.876Z",
    fill: "#391D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.575 91.0968C292.844 93.2692 293.954 96.9382 293.954 102.104C293.954 109.731 291.927 113.207 286.375 114.655L295.402 128.993C295.837 129.573 295.547 130.055 294.775 130.055H285.023C283.913 130.055 283.478 129.717 282.899 128.897L274.306 115.331H272.278V129.235C272.278 129.911 272.133 130.104 271.506 130.104H261.947C261.32 130.104 261.175 129.959 261.175 129.235V89.2623C261.175 88.8278 261.416 88.6347 261.947 88.5864C267.209 88.1037 272.761 87.8623 278.747 87.8623C284.347 87.8623 288.306 88.9244 290.575 91.0968ZM272.278 97.5657V107.221H277.54C281.499 107.221 282.658 106.062 282.658 102.49C282.658 98.9175 281.402 97.5657 277.54 97.5657H272.278Z",
    fill: "#391D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.728 88.1504C344.114 88.1504 344.307 88.4883 344.355 89.0676L348.555 129.233C348.603 129.812 348.362 130.15 347.783 130.15H338.224C337.741 130.15 337.5 129.812 337.452 129.233L335.231 108.185L327.555 127.93C327.314 128.509 326.928 128.847 326.348 128.847H320.121C319.541 128.847 319.155 128.509 318.914 127.93L311.286 108.185L309.017 129.233C308.969 129.812 308.679 130.15 308.245 130.15H298.686C298.107 130.15 297.817 129.812 297.914 129.233L302.114 89.1159C302.162 88.5366 302.355 88.1987 302.741 88.1987H311.334C313.507 88.1987 314.472 88.6331 315.1 90.3711L323.307 112.095L331.514 90.3228C332.141 88.5849 333.107 88.1504 335.279 88.1504H343.872H343.728Z",
    fill: "#391D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.54 129.282C389.637 129.862 389.444 130.151 388.864 130.151H379.595C379.113 130.151 379.064 130.006 378.871 129.282L376.071 118.903H363.568L360.768 129.282C360.623 129.91 360.575 130.151 360.044 130.151H350.775C350.195 130.151 350.002 129.91 350.099 129.282L359.658 94.3787C360.43 91.4339 361.444 89.5994 362.554 88.9236C363.664 88.2477 366.127 87.9098 369.844 87.9098C373.561 87.9098 376.023 88.296 377.133 88.9719C378.244 89.6477 379.258 91.4822 380.03 94.3787L389.589 129.282H389.54ZM380.175 75.8891C380.561 75.8891 380.706 76.0339 380.706 76.4201V76.8063C380.706 77.0477 380.609 77.2891 380.464 77.4339L369.506 86.2201C369.506 86.2201 369.071 86.365 368.782 86.2201L365.354 84.2891C365.113 84.1443 365.016 83.8546 365.209 83.565L369.071 76.1787C369.071 76.1787 369.409 75.8408 369.699 75.8408H380.223L380.175 75.8891ZM365.982 109.924H373.609L370.182 97.4201C370.037 96.9856 369.506 96.9856 369.313 97.4201L365.982 109.924Z",
    fill: "#391D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.194 88.9726C421.305 89.3589 421.739 89.6968 421.739 90.7588V96.6968C421.739 97.2761 421.498 97.5657 420.967 97.5657H409.284C406.58 97.5657 404.843 98.3382 403.974 99.9313C403.105 101.524 402.718 104.517 402.718 109.055C402.718 113.593 403.153 116.635 403.974 118.276C404.843 119.869 406.58 120.642 409.284 120.642H420.967C421.498 120.642 421.739 120.883 421.739 121.511V127.449C421.739 128.559 421.256 128.993 420.194 129.235C417.587 129.959 413.967 130.345 409.236 130.345C402.236 130.345 397.553 128.849 395.043 125.904C392.629 122.959 391.374 117.311 391.374 109.055C391.374 100.8 392.291 95.683 395.043 92.352C397.843 88.9726 402.042 87.8623 409.236 87.8623C413.725 87.8623 417.394 88.2485 420.194 88.9726Z",
    fill: "#391D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.851 88.1973C437.382 88.1973 437.623 88.5352 437.623 89.1145V129.232C437.623 129.811 437.382 130.149 436.851 130.149H427.292C426.761 130.149 426.52 129.811 426.52 129.232V89.1145C426.52 88.5352 426.761 88.1973 427.292 88.1973H436.851Z",
    fill: "#391D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.203 129.283C480.3 129.862 480.107 130.152 479.528 130.152H470.259C469.776 130.152 469.727 130.007 469.534 129.283L466.734 118.903H454.231L451.431 129.283C451.286 129.91 451.238 130.152 450.707 130.152H441.438C440.859 130.152 440.665 129.91 440.762 129.283L450.321 94.3791C451.093 91.4343 452.107 89.5998 453.217 88.924C454.327 88.2481 456.79 87.9102 460.507 87.9102C464.224 87.9102 466.686 88.2964 467.796 88.9722C468.907 89.6481 469.921 91.4826 470.693 94.3791L480.252 129.283H480.203ZM456.645 109.876H464.272L460.845 97.3722C460.7 96.9377 460.169 96.9377 459.976 97.3722L456.645 109.876Z",
    fill: "#391D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5443 98.8193L-0.000488281 115.281L46.9719 138.695L79.4133 99.0124C79.1236 98.9642 78.834 98.8676 78.5443 98.8193Z",
    fill: "url(#paint0_linear_261_3400)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.725 92.0125L179.442 110.744L147.532 69.0332L103.166 89.4056C104.18 90.1298 105.049 90.9987 105.676 92.0608L105.725 92.0125Z",
    fill: "url(#paint1_linear_261_3400)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7391 87.621H76.4219L16.0288 37.4141L26.8909 88.8278L71.7391 89.4554V87.621Z",
    fill: "url(#paint2_linear_261_3400)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.25 87.6186H97.7603C99.7879 87.6186 101.622 88.2462 103.167 89.3566L147.533 68.9841L107.753 59.2324L95.25 81.5359V87.6669V87.6186Z",
    fill: "url(#paint3_linear_261_3400)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.585 99.5928L142.268 122.282L130.295 173.407L95.585 99.5928Z",
    fill: "url(#paint4_linear_261_3400)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7228 80.8621L86.7504 0L53.1504 40.3586L84.5297 81.2965C84.5297 81.2965 84.6745 81.0069 84.7228 80.8621Z",
    fill: "url(#paint5_linear_261_3400)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7354 89.7429V89.4532L26.8389 88.7773L58.5561 114.75L79.9906 99.1084C75.3561 98.5291 71.7354 94.5705 71.7354 89.7429Z",
    fill: "url(#paint6_linear_261_3400)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3588 87.6224H83.7106V85.1121C83.7106 83.7603 84.0002 82.4569 84.5312 81.2983L53.1519 40.3604L52.4761 81.3466L75.1657 87.6707H82.3588V87.6224Z",
    fill: "url(#paint7_linear_261_3400)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1717 75.6964H95.2958V77.2895L107.172 33.0205L74.2476 57.3998L84.2407 82.1171C85.4958 78.3998 89.02 75.6964 93.1717 75.6964Z",
    fill: "url(#paint8_linear_261_3400)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.55 85.3027L103.357 89.4545C105.723 91.1924 107.219 93.9441 107.219 97.082V99.2062H95.3916L95.5847 99.5924L142.267 122.282L124.55 85.351V85.3027Z",
    fill: "url(#paint9_linear_261_3400)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9037 99.2061H95.2485V101.716C95.2485 105.385 93.1727 108.572 90.083 110.116L99.352 152.841L117.455 116.054L97.9037 99.2061Z",
    fill: "url(#paint10_linear_261_3400)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8362 111.177H83.8569L51.8018 175.046L99.4018 152.839L90.1328 110.115C88.8293 110.791 87.3811 111.177 85.8362 111.177Z",
    fill: "url(#paint11_linear_261_3400)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8353 111.178H83.7111V99.2058H81.2008C80.6215 99.2058 79.9939 99.1575 79.4629 99.0127L47.0215 138.695L87.0422 129.958L87.8146 110.937C87.187 111.082 86.5111 111.13 85.8353 111.13V111.178Z",
    fill: "url(#paint12_linear_261_3400)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.25 81.9244L159.602 35.0485L107.174 32.9727L95.25 77.2416V81.9244Z",
    fill: "url(#paint13_linear_261_3400)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_261_3400",
    x1: 9.55813,
    y1: 125.275,
    x2: 63.1926,
    y2: 118.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C00D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8600CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#61008B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#490064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#410055"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_261_3400",
    x1: 133.676,
    y1: 85.1573,
    x2: 166.842,
    y2: 106.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#144F28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#196935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D783E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_261_3400",
    x1: 57.1598,
    y1: 89.1175,
    x2: 18.7805,
    y2: 61.1658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#990734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D80940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_261_3400",
    x1: 99.4017,
    y1: 77.2876,
    x2: 131.264,
    y2: 62.4669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#218143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#28964D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DA555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_261_3400",
    x1: 120.206,
    y1: 120.882,
    x2: 126.771,
    y2: 171.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA880C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB829"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_261_3400",
    x1: 70.6745,
    y1: 52.1379,
    x2: 78.0607,
    y2: 15.5448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#2C2C9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3131AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_261_3400",
    x1: 69.5147,
    y1: 99.6394,
    x2: 47.7423,
    y2: 101.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3083A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_261_3400",
    x1: 81.9244,
    y1: 69.9535,
    x2: 59.6692,
    y2: 63.0017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3CBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#5858D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6767E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_261_3400",
    x1: 94.2338,
    y1: 75.5998,
    x2: 92.0614,
    y2: 56.8688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_261_3400",
    x1: 113.254,
    y1: 94.3786,
    x2: 129.426,
    y2: 103.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEA71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_261_3400",
    x1: 109.683,
    y1: 139.758,
    x2: 100.124,
    y2: 99.6405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_261_3400",
    x1: 85.3535,
    y1: 139.081,
    x2: 58.6569,
    y2: 169.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_261_3400",
    x1: 65.7042,
    y1: 136.04,
    x2: 88.8284,
    y2: 105.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A3FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#933DBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#793898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#6F3789"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_261_3400",
    x1: 140.629,
    y1: 33.552,
    x2: 99.6431,
    y2: 58.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8590A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B54309"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_261_3400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 480.248,
    height: 175,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUdfLogo);
export default __webpack_public_path__ + "static/media/udf-logo.2cd754c95ce33c0db7afa200df4e5b57.svg";
export { ForwardRef as ReactComponent };